<template>

    <div>

        <v-alert class="ml-5 mr-10" v-show="apiError" max-width="900" type="warning">{{ apiError }}</v-alert>

        <v-card class="d-flex flex-row" max-width="1200">

            <v-card tile flat color="grey darken-2" class="pa-3 d-flex">

                <v-card color="white" width="200" height="200" :style="enabledModel ? 'opacity: 1' : 'opacity: 0.5'">
                    <v-img max-height="200"
                           max-width="200"
                           width="200"
                           height="200"
                           contain
                           :src="cdnBaseUrl('img/paypal-logo.png')"
                    ></v-img>
                </v-card>

                <div class="d-flex flex-column justify-space-between">

                    <v-card-text class="flex-grow-1">
                        <p>
                            PayPal integration enables you distribute rewards to your panelists a very convenient way.
                            Distribute cash rewards in multiple currencies and countries. PayPal accounts
                            support funding operations using multiple currencies for reduced exchange fees.
                        </p>
                    </v-card-text>

                    <v-card-text class="mt-2">

                        <v-btn class="mt-2"
                               color="primary"
                               v-show="partner"
                               @click="manageRewardsClicked">
                            Manage Rewards
                        </v-btn>

                        <v-btn class="mt-2"
                               :color="!enabledModel ? 'primary' : ''"
                               :text="enabledModel"
                               @click="configureClicked">
                            Configure
                        </v-btn>

                        <v-btn
                            class="mt-2"
                            v-show="partner"
                            :text="enabledModel? true : false"
                            :color="enabledModel ? 'white' : 'primary'"
                            @click="partnerEnabledChanged">
                            {{ enabledModel ? 'DISABLE' : 'ENABLE' }}
                        </v-btn>

                        <v-btn text
                               class="mt-2"
                               @click="apiKeysClicked">
                            <v-icon left>mdi-information-outline</v-icon>
                            API Keys
                        </v-btn>

                    </v-card-text>
                </div>
            </v-card>

            <v-card tile flat color="grey darken-2" min-width="300">
                <v-card-text>

                    <stat-box-skinny-numerical v-for="(balance, index) in balances"
                                               :key="index"
                                               class="mb-1"
                                               :value="balance.balance_cents/100"
                                               :hint="balance.currency"
                                               :prefix-icon="getCurrencyPrefixIcon(balance.currency)"
                                               :postfix-icon="getCurrencyPostfixIcon(balance.currency)"
                    ></stat-box-skinny-numerical>

                </v-card-text>

            </v-card>

            <div v-show="enabledModel" style="border-left: 5px solid green"/>
            <div v-show="!enabledModel" style="border-left: 5px solid red"/>
        </v-card>

        <pay-pal-management-dialog v-model="manageDialogModel"></pay-pal-management-dialog>

        <pay-pal-configure-dialog :partner="partner"
                                  :active="enabledModel"
                                  v-model="configureDialogModel"
        ></pay-pal-configure-dialog>

        <confirmation-dialog
            v-model="disableConfirmationModel"
            delete
            @selected="partnerDisabledConfirmation"
            confirm-button-text="I know what I am doing"
            headline="Disable PayPal rewards?">
            If you disable PayPal rewards your panelist can no longer see or request PayPal redemptions.
            In addition the system will no longer process PayPal redemptions even if approved in the Redemption Approvals.
            You can later enable PayPal rewards with a single click.
            Are you sure?
        </confirmation-dialog>

    </div>

</template>

<script>

import Store from '../../store';
import {mapActions, mapState} from 'vuex';
import PayPalManagementDialog from "./PayPalManagementDialog";
import PayPalConfigureDialog from "./PayPalConfigureDialog";
import ConfirmationDialog from "../../../../components/UI/ConfirmationDialog";
import StatBoxSkinnyNumerical from "../../../../components/UI/StatBoxSkinnyNumerical";
import {currencyMixin} from "../../../../components/mixins/currencyMixin";

const vuexModule = 'Rewards';

export default {

    mixins: [currencyMixin],

    components: {
        StatBoxSkinnyNumerical,
        PayPalManagementDialog,
        PayPalConfigureDialog,
        ConfirmationDialog,
    },

    data() {
        return {
            manageDialogModel: false,
            configureDialogModel: false,
            disableConfirmationModel: false,
        }
    },

    computed: {
        ...mapState(vuexModule, [
            'partners'
        ]),

        enabledModel: {
            get() {
                return !!this.partners.find(partner => {
                    if (partner.type === 'PayPal' && partner.enabled) {
                        return true;
                    }
                });
            },
            set(value) {
                value ? this.enablePartner(this.partner.id) : this.disablePartner(this.partner.id);
            }
        },

        apiError() {
            if (this.partner && this.partner.error) {
                return this.partner.error;
            }
        },

        partner() {
            return this.partners.find(partner => partner.type === 'PayPal');
        },

        balances() {
            // If there is an error balance might not exist
            if (this.partner) {
                return this.partner.balances;
            }
            return [];
        },

        currency() {
            if (this.partner) {
                return this.partner.currency ? this.partner.currency : '';
            }
        },
    },

    methods: {

        ...mapActions(vuexModule, [
            'disablePartner',
            'enablePartner',
            'getPayPalCurrencies'
        ]),


        apiKeysClicked() {
            this.sendToUrl('https://developer.paypal.com/', true);
        },

        configureClicked() {
            this.configureDialogModel = true;
        },

        manageRewardsClicked() {
            this.manageDialogModel = true;
        },

        partnerEnabledChanged() {
            if (this.enabledModel) {
                this.disableConfirmationModel = true;
            } else {
                this.enabledModel = true;
                this.enablePartner(this.partner.id);
                Bus.$emit('flash-message', {type: 'success', message: 'PayPal rewards are now enabled!'});
            }
        },

        partnerDisabledConfirmation(value) {
            if (value) {
                this.enabledModel = false;
                this.disablePartner(this.partner.id);
                Bus.$emit('flash-message', {type: 'warning', message: 'PayPal rewards are now disabled!'});
            }
        },
    },

    created() {
        if (!this.$store.state[vuexModule]) {
            this.$store.registerModule(vuexModule, Store);
        }
    },
}
</script>
